module.exports = __webpack_public_path__ + "static/media/sarafan-logo.e48d156d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sarafan-logo.png
// module id = 427
// module chunks = 0